import React, { PropsWithChildren, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import Styles from './SplashScreen.module.scss'

export const Portal: React.FC<PropsWithChildren> = ({ children }) => {
  const [container] = useState(document.createElement('div'))

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    document.body.appendChild(container)
    return () => {
      document.body.style.overflow = 'visible'
      document.body.removeChild(container)
    }
  }, [container])

  return createPortal(children, container)
}

const BouncyDots = () => {
  return (
    <div className={Styles.bouncyWrapper}>
      <div className={Styles.bouncyDots}>
        <div className={Styles.dot} />
        <div className={Styles.dot} />
        <div className={Styles.dot} />
        <div className={Styles.dot} />
      </div>
    </div>
  )
}

const SplashScreen = () => {
  return (
    <Portal>
      <div className={Styles.portalContainer} data-testid="splash-screen">
        <div className={Styles.animationWrapper}>
          <div className={Styles.logoWrapper}>
            <img
              width="255"
              src="/images/yassir-express-text-logo.svg"
              alt="Splash Screen"
            />
          </div>
          <BouncyDots />
        </div>
      </div>
    </Portal>
  )
}

export default SplashScreen
